import _ from 'lodash';
import AppConstatnt from '../../../../../config/app.constants';

class PrintController {
    /*@ngInject*/
    constructor(ShipmentService, BagoutService, TransactionService, $translate, $q, Modal, DateUtil) {
        this.ShipmentService = ShipmentService;
        this.BagoutService = BagoutService;
        this.TransactionService = TransactionService;
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.branchId = "";
        this.endDate = "";
        this.searchText = "";
        this.startDate = "";
        this.vaultDate = "";
        this.currentStats = "";
        this.locationType = "";
        this.Modal = Modal;
        this.toLocationSearchText = "";
        this.fromLocationSearchText = "";
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
            this.branchId = printData.branchId;
            this.endDate = printData.endDate;
            this.searchText = printData.searchText;
            this.startDate = printData.startDate;
            this.vaultDate = printData.vaultDate;
            this.customerId = printData.customerId || null;
            this.currentStats = printData.currentStats;
            this.loading = true;
            this.timezone = printData.timezone;
            this.locationType = printData.locationType;
            this.toLocationSearchText = printData.toLocationSearchText;
            this.fromLocationSearchText = printData.fromLocationSearchText;
            this.selectedDepositAmountValue = printData.selectedDepositAmountValue;
            this.deliveryServiceHistoryObj = printData.deliveryServiceHistoryObj;
            this.atmServiceHistoryObj = printData.atmServiceHistoryObj;
            this.pickupServiceHistoryObj = printData.pickupServiceHistoryObj;
            this.noPickupServiceHistoryObj = printData.noPickupServiceHistoryObj;

            if (this.currentStats === 'ServiceHistory') {
                return this.ShipmentService.ServiceItemHistory(this.searchText, this.startDate, this.endDate, 0, 5000, this.atmServiceHistoryObj.sortColumn, this.atmServiceHistoryObj.reverseSort)
                    .then((data) => {
                        this.loading = false;
                        this.serviceHistory = data;

                        const orderNoGrp = new Map();
                        data.results.forEach(cur => {
                            const key = cur.parentLoadTrackingId;
                            if (!orderNoGrp.has(key)) {
                                orderNoGrp.set(key, {
                                    commonAttributes: {}, // to store shared attributes
                                    orders: [] // to store individual orders
                                });
                            }
                            orderNoGrp.get(key).orders.push(cur);
                        });
                        // Extract common attributes and prepare final grouped data
                        const groupedData = Array.from(orderNoGrp.entries()).map(([key, group]) => {
                            const commonOrder = group.orders[0];

                            return {
                                orderNo: commonOrder.orderNo,
                                deliveryAmount: group.orders.reduce((sum, order) => sum + order.deliveryAmount, 0),
                                serviceDate: commonOrder.serviceDate,
                                orderType: commonOrder.orderType,
                                status: commonOrder.status,
                                deletedReason: commonOrder.deletedReason,
                                transType: commonOrder.transType || null,
                                routeId: commonOrder.routeId,
                                toLocationId: commonOrder.toLocationId,
                                toLocationName: commonOrder.toLocationName,
                                loadTrackingId: commonOrder.parentLoadTrackingId,
                                residualTrackingId: commonOrder.parentResidualTrackingId,
                                isEC: commonOrder.isEC,
                                deliveryDate: commonOrder.deliveryDate,
                                deliveredFlag: commonOrder.deliveredFlag,
                                fromLocationId: commonOrder.fromLocationId,
                                fromLocationName: commonOrder.fromLocationName,
                                residualAmount: group.orders.reduce((sum, order) => sum + order.residualAmount, 0),
                                loadedAmount: group.orders.reduce((sum, order) => sum + order.loadedAmount, 0),
                                amountCounted: group.orders.reduce((sum, order) => sum + order.amountCounted, 0),
                                amountCRV: group.orders.reduce((sum, order) => sum + order.amountCRV, 0),
                                denominations: _.uniqBy(group.orders.filter(order => order.denominationId), 'denominationId').map(order => ({
                                    denominationId: order.denominationId,
                                    deliveryAmount: order.deliveryAmount,
                                    amountCounted: order.amountCounted,
                                })),
                                parentLoadShipmentDetails: commonOrder.parentLoadShipmentDetails,
                                parentResidualShipmentDetails: commonOrder.parentResidualShipmentDetails,
                                finishedAt: commonOrder.finishedAt,
                                amountVariance: commonOrder.amountVariance
                            };
                        });
                        this.serviceHistory.results = groupedData;
                        this.serviceHistoryTotal = data.total;
                        this.print();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else if (this.currentStats === 'ItemHistory') {
                return this.ShipmentService.LocationsItemHistory(this.searchText, this.startDate, this.endDate, 0, 5000)
                    .then((data) => {
                        this.loading = false;
                        this.itemHistory = data;
                        this.print();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else if (this.currentStats === 'deliveryServiceHistory') {
                return this.ShipmentService.printDeliveryServiceHistory(this.searchText, this.startDate, this.endDate, this.timezone, this.fromLocationSearchText, this.deliveryServiceHistoryObj.sortColumn, this.deliveryServiceHistoryObj.reverseSort)
                    .then((data) => {
                        this.loading = false;
                        this.deliveryServiceHistoryData = data;
                        this.print();
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
            }
            else if (this.currentStats === 'pickupServiceHistory') {
                return this.ShipmentService.printPickupServiceHistory(this.searchText, this.startDate, this.endDate, this.timezone, this.toLocationSearchText, this.pickupServiceHistoryObj.sortColumn, this.pickupServiceHistoryObj.reverseSort)
                    .then((data) => {
                        this.loading = false;
                        this.pickupServiceHistoryData = data;
                        this.print();
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
            }
            else if (this.currentStats === 'noPickupHistory') {
                return this.TransactionService.printNoPickupTransactionHistory(this.searchText, this.startDate, this.endDate, this.timezone, this.noPickupServiceHistoryObj.sortColumn, this.noPickupServiceHistoryObj.reverseSort)
                    .then((data) => {
                        this.loading = false;
                        this.noPickupServiceHistoryData = data;
                        this.print();
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
            }
            else {
                return this.BagoutService.getBagoutData(this.searchText, this.startDate, this.endDate, this.customerId, 0, 5000)
                    .then((data) => {
                        this.loading = false;
                        this.bagOutData = data.results;
                        this.print();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        }
    }

    getOrderType(type) {
        return this.ShipmentService.getOrderType(type)
    }

    convertTime(microSeconds) {
        return this.ShipmentService.convertTime(microSeconds);
    }

    translateItemStatus(status) {
        if (!status) return;
        else return this.$translate.instant(status);
    }

    print() {
        setTimeout(() => {
            window.print()
        }, 1000)
    }

    translateTransactionType(tranType) {
        if (!tranType) return;
        else return this.$translate.instant(`shipment.${tranType}`);
    }

    setAmount(obj) {
        if (!obj) return;
        return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
        // const status = ['Hold'];

        // if (status.includes(this.translateItemStatus(obj.status))) {
        //     return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
        // }
        // else return obj.formattedLoadedAmount
    }
}
export default PrintController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/locations/print/print.controller.js